function publicationsSwiper() {
    if (typeof Swiper !== 'undefined') {
        if (window.innerWidth >= 800) {
            const publicationsLogosSwiper = new Swiper(`.publication_logos_swiper`, {
                slidesPerView: 1,
                fadeEffect: {
                    crossFade: true
                },
                loop: true,
                autoplay: {
                    delay: 3000,
                },
                spaceBetween: 30,
                breakpoints: {
                    800: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        effect: 'slide'
                    },
                    1200: {
                        slidesPerView: 6,
                        spaceBetween: 30,
                        effect: 'slide'
                    },
                    1400: {
                        slidesPerView: 6,
                        spaceBetween: 80,
                        effect: 'slide'
                    },
                }
            });
        } else {
            const publicationsLogosSwiper = new Swiper(`.publication_logos_swiper`, {
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                loop: true,
                autoplay: {
                    delay: 3000,
                },
                spaceBetween: 30,
                breakpoints: {
                    800: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        effect: 'slide'
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        effect: 'slide'
                    },
                    1400: {
                        slidesPerView: 4,
                        spaceBetween: 80,
                        effect: 'slide'
                    },
                }
            });
        }
    } else {
        setTimeout(publicationsSwiper, 100);
    }
}

publicationsSwiper();